export const THIRTY_ONE_DAY_BILLING_CODES_FOR_LETTER = ["93298", "93298 26"];
export const NINETY_ONE_DAY_BILLING_CODES_FOR_LETTER = ["93294", "93295"];
